import {
  GET_CLIENT_FILES,
  GET_CLIENT_FILES_SUCCESS,
  GET_CLIENT_FILES_ERROR,
  UPLOAD_CLIENT_FILE,
  UPLOAD_CLIENT_FILE_SUCCESS,
  UPLOAD_CLIENT_FILE_ERROR,
  DELETE_CLIENT_FILE,
  DELETE_CLIENT_FILE_SUCCESS,
  DELETE_CLIENT_FILE_ERROR,
} from './constants';

const initialState = {
  list: [],
  loading: false,
  err: null,
  uploading: false,
  uploadErr: null,
  deleting: false,
  deleteErr: null,
};

export default function sharedFile(state = initialState, action) {
  switch (action.type) {
    case GET_CLIENT_FILES:
      return { ...state, loading: true, err: null };
    case GET_CLIENT_FILES_SUCCESS:
      return {
        ...state,
        list: Array.isArray(action.payload) ? action.payload : [],
        loading: false,
        err: null,
      };
    case GET_CLIENT_FILES_ERROR:
      return { ...state, loading: false, err: action.err };

    case UPLOAD_CLIENT_FILE:
      return { ...state, uploading: true, uploadErr: null };
    case UPLOAD_CLIENT_FILE_SUCCESS:
      return {
        ...state,
        uploading: false,
        list: action.payload ? [action.payload, ...state.list] : state.list,
      };
    case UPLOAD_CLIENT_FILE_ERROR:
      return { ...state, uploading: false, uploadErr: action.err };

    case DELETE_CLIENT_FILE:
      return { ...state, deleting: true, deleteErr: null };
    case DELETE_CLIENT_FILE_SUCCESS:
      return {
        ...state,
        deleting: false,
        list: state.list.filter(
          (f) => String(f._id) !== String(action.fileId)
        ),
      };
    case DELETE_CLIENT_FILE_ERROR:
      return { ...state, deleting: false, deleteErr: action.err };

    default:
      return state;
  }
}
